// src/components/AIAssistant.jsx
import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { getDailyInsights } from "../utils/gemini";
import { getLiveAppCtx } from "../utils/aiContext";
import { theme } from "../utils/theme";

const C = theme.colors;

const AIAssistant = () => {
  const [insights, setInsights] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    async function load() {
      const apiKey = process.env.REACT_APP_GEMINI_API_KEY;
      if (!apiKey) {
        setLoading(false);
        return; // Key missing, show nothing or setup prompt
      }

      // Check cache (localStorage) to avoid hitting API on every refresh
      const today = new Date().toDateString();
      const cached = localStorage.getItem("gemini_daily_insights");
      if (cached) {
        const parsed = JSON.parse(cached);
        if (parsed.date === today) {
          setInsights(parsed.data);
          setLoading(false);
          return;
        }
      }

      try {
        const liveCtx = await getLiveAppCtx();
        const data = await getDailyInsights(new Date(), liveCtx);
        if (data) {
          setInsights(data);
          localStorage.setItem("gemini_daily_insights", JSON.stringify({ date: today, data }));
        }
      } catch (err) {
        setError(err.message);
      }
      setLoading(false);
    }
    load();
  }, []);

  if (!process.env.REACT_APP_GEMINI_API_KEY) {
    return (
      <div style={{ background: C.accentSoft, border: `1px dashed ${C.accent}`, borderRadius: 12, padding: 16, marginBottom: 24 }}>
        <div style={{ fontSize: 14, fontWeight: 700, color: C.accent, marginBottom: 4 }}>✨ AI Features Waiting</div>
        <div style={{ fontSize: 12, color: C.muted }}>Add your Life AI (Gemini) API Key to `.env` to see AI-powered Panchang and Daily Thoughts.</div>
      </div>
    );
  }

  if (loading) return null; // Keep UI clean while loading

  if (!insights) return null;

  return (
    <div className="fade" style={{ background: C.surface, border: `1px solid ${C.border}`, borderRadius: 12, padding: 18, marginBottom: 24, boxShadow: theme.shadows.soft }}>
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", marginBottom: 14 }}>
        <div>
          <div style={{ fontSize: 12, fontWeight: 700, color: C.accent, textTransform: "uppercase", letterSpacing: 1, marginBottom: 4 }}>✨ Life AI Insight</div>
          <div style={{ fontSize: 16, fontWeight: 700, color: C.text }}>{insights.tithi} {insights.paksha ? `(${insights.paksha})` : ""}</div>
          <div style={{ fontSize: 13, color: C.muted }}>{insights.month} {insights.samvat} Vikram Samvat</div>
        </div>
        <div style={{ textAlign: "right", display: "flex", flexDirection: "column", alignItems: "flex-end", gap: 8 }}>
          {insights.festivals && insights.festivals.length > 0 && (
            <div style={{ display: "flex", flexWrap: "wrap", justifyContent: "flex-end", gap: 4 }}>
              {insights.festivals.map((f, i) => (
                <div key={i} style={{ fontSize: 11, fontWeight: 600, color: C.red, background: C.redSoft, padding: "2px 8px", borderRadius: 4 }}>🎉 {f}</div>
              ))}
            </div>
          )}
          <Link 
            to="/admin/ai-chat" 
            style={{ 
              fontSize: 12, 
              fontWeight: 600, 
              color: "#fff", 
              background: C.accent, 
              padding: "6px 12px", 
              borderRadius: 8, 
              textDecoration: "none",
              display: "inline-block",
              boxShadow: theme.shadows.accent
            }}
          >
            Ask Life AI →
          </Link>
        </div>
      </div>

      <div style={{ borderTop: `1px solid ${C.border}`, paddingTop: 14 }}>
        <div style={{ fontSize: 12, fontWeight: 600, color: C.muted, marginBottom: 6 }}>THOUGHT OF THE DAY</div>
        <div style={{ fontSize: 15, fontWeight: 500, color: C.text, fontStyle: "italic", lineHeight: 1.5 }}>
          "{insights.thought}"
        </div>
      </div>
    </div>
  );
};

export default AIAssistant;
